export default "__VITE_ASSET__2833c868__"